import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";
import TryItButton from "../../../TryItButton";
import OutputBox from "../../../OutputBox";

export default function JS_Loops_for_in() {
  return (
    <div className="tutorial-container read-only">
      <h1 className="tutorial-title">🔁 JavaScript for...in Loop</h1>

      {/* Explanation */}
      <div className="tutorial-section">
        <h2 className="section-title">💡 What is a for...in loop?</h2>
        <p>
          The <code className="highlight_code ">for...in</code> loop iterates
          over the <b>keys (properties)</b> of an object. It's useful for
          accessing object properties dynamically.
        </p>
        <div
          style={{
            background: "linear-gradient(135deg, #fef3c7, #fde68a)",
            padding: "1rem",
            borderRadius: "12px",
            marginTop: "2rem",
            paddingLeft: "35px",
          }}
        >
          <h3 style={{ color: "#92400e" }}>🛠 How it works:</h3>
          <ol className="tutorial-list-points">
            <li>
              <b>Initialization:</b> Declare a variable to store each key, e.g.,{" "}
              <code className="highlight_code ">key</code>.
            </li>
            <li>
              <b>Loop:</b> JavaScript loops over all enumerable keys in the
              object.
            </li>
            <li>
              <b>Code Block:</b> Access the value with{" "}
              <code className="highlight_code ">object[key]</code>.
            </li>
          </ol>
        </div>
      </div>

      {/* Example 1 */}
      <div className="tutorial-section">
        <h2 className="section-title">1️⃣ Iterating Object Properties</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`let course = {name: "JavaScript", level: "Beginner", institute: "Edu-Tech Master Academy"};
for (let key in course) {
  console.log(key + ":", course[key]);
}`}
          />
          <TryItButton
            code={`let course = {name: "JavaScript", level: "Beginner", institute: "Edu-Tech Master Academy"};
for (let key in course) {
  console.log(key + ":", course[key]);
}`}
          />
        </div>
        <OutputBox>
          <pre>
            name: JavaScript{"\n"}
            level: Beginner{"\n"}
            institute: Edu-Tech Master Academy
          </pre>
        </OutputBox>
      </div>

      {/* Example 2 */}
      <div className="tutorial-section">
        <h2 className="section-title">2️⃣ Counting Object Properties</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`let student = {name: "John", age: 20, course: "React"};
let count = 0;
for (let prop in student) {
  count++;
}
console.log("Total properties at Edu-Tech Master Academy:", count);`}
          />
          <TryItButton
            code={`let student = {name: "John", age: 20, course: "React"};
let count = 0;
for (let prop in student) {
  count++;
}
console.log("Total properties at Edu-Tech Master Academy:", count);`}
          />
        </div>
        <OutputBox>
          <pre>Total properties at Edu-Tech Master Academy: 3</pre>
        </OutputBox>
      </div>

      {/* Next Steps */}
      <div
        style={{
          background: "linear-gradient(135deg, #dbeafe, #bfdbfe)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "2rem",
        }}
      >
        <h2 style={{ color: "#1e40af" }}>🚀 Next Steps</h2>
        <ul className="tutorial-list-points">
          <li>
            Compare <code className="highlight_code ">for...in</code> vs{" "}
            <code className="highlight_code ">for...of</code>.
          </li>
          <li>Practice iterating nested objects.</li>
          <li>Combine with functions to dynamically access properties.</li>
        </ul>
      </div>
    </div>
  );
}
